<template>
  <div class="container">
    <h2>《个人信息保护声明》</h2>
    <div class="docs">
      <p>尊敬的用户，您好：</p>
      <p style="text-indent: 2em;">
        西亚招聘系统是西亚和美公司在全国范围使用，进行招聘活动的招聘工具。通过这一应用在求职者所在地区提供求职机会。您在该招聘系统上输入的个人数据仅用于人员招募用途。
      </p>
      <p style="text-indent: 2em;">
        西亚深知个人数据保护对您的重要性，将按照所适用的数据保护相关法律法规的要求，在全国范围内保护您的个人数据。
        当您向我们提交您的个人数据前，请仔细阅读、了解本声明内容，您投递意向职位并发送职位申请时，视为您完全知晓并且同意如下内容。西亚会如何使用您的个人数据用于以下招聘目的：
      </p>
      <p class="line">1、候选人识别和联系</p>
      <p class="line">2、对候选人进行评估并作出录用决策</p>
      <p class="line">3、保留招聘流程的相关记录</p>
      <p class="line">4、使用这些数据来挖掘其他西亚职业发展机会</p>
      <p class="line">5、在确认出现职位空缺后联系职位候选人</p>
      <p>
        请注意,本声明仅适用于西亚招聘APP应用,包括显示或提及本声明的智能手机、平板电脑、计算机应用程序、工具、软件、网站以及服务。
      </p>
      <p>
        提示：简历信息和岗位/部门投递信息将作为面试和录用安排的重要依据,简历确认投递后未受理前可修改,受理后将暂停修改,请谨慎操作。
      </p>
    </div>
  </div>
</template>
<style scoped>
.docs {
    font-size: 0.8rem;
    padding: 1.2em;
    text-align:left;
    color:rgb(90, 90, 90);
    height:60vh;
    overflow: scroll;
}
.docs .line{
    padding:0;
    margin:5px
}
</style>